import { render, staticRenderFns } from "./simpleMoneyTable.vue?vue&type=template&id=95810bda&scoped=true"
import script from "./simpleMoneyTable.vue?vue&type=script&lang=js"
export * from "./simpleMoneyTable.vue?vue&type=script&lang=js"
import style0 from "./simpleMoneyTable.vue?vue&type=style&index=0&id=95810bda&prod&lang=css"
import style1 from "../../statistics/css/moneyTable.css?vue&type=style&index=1&id=95810bda&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95810bda",
  null
  
)

export default component.exports